// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  #Planning.planning-page {

    display: flex;
    flex-direction: column;
  }
  
  .card-container.grid {
    flex: 1 1; /* Nimmt den verfügbaren Platz ein */
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Verhindert Scrollbars außerhalb des Schedulers */
  }
  
  .card-component {
    flex: 1 1; /* Scheduler-Container nimmt den restlichen Platz ein */
    height: 100%; /* Volle Höhe des Containers */
  }
  
  /* Überschreibt die Standardhöhe des Kendo Schedulers */
  .k-scheduler {
    height: 100% !important; /* Erzwingt die volle Höhe */
  }
  
  /* Optional: Sicherstellen, dass interne Scheduler-Elemente die Höhe nutzen */
  .k-scheduler-content,
  .k-scheduler-table,
  .k-scheduler-layout {
    height: 100% !important; /* Stellt sicher, dass der Inhalt mitwächst */
  }
  
  /* Entferne den Standard-Hintergrund des Kendo-Popups */
  .k-window-content.k-dialog-content {
      background: transparent !important;
      padding: 0 !important;
    }
    
    /* Stelle sicher, dass das Popup sich an den Inhalt anpasst */
    .k-window.k-dialog {
      max-height: 90vh;
    }
    
    /* Wrapper für die gesamte Form inklusive Buttons */
    .custom-scheduler-form-wrapper {
      background-color: #fff;
      padding: 20px;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      min-width: 300px;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    
    /* Form-Inhalt */
    .custom-scheduler-form-content {
      flex-grow: 1;
    }
    
    /* Felder */
    .form-field {
      margin-bottom: 15px;
      font-family: Arial, sans-serif !important;
    }
    
    /* Spezifisches Styling für das Description-Feld */
    .form-field-description {
      width: 340px;
      margin-top: 20px;
      margin-bottom: 15px;
      font-family: Arial, sans-serif !important;
    }
    
    /* Styling für das nicht-editierbare Description-Feld */
    .description-display {
      width: 100%;
      min-height: 60px; /* Mindesthöhe wie eine Textarea */
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: #f5f5f5; /* Leicht grau, um "nicht editierbar" zu signalisieren */
      white-space: pre-wrap; /* Zeilenumbrüche erhalten */
      font-family: Arial, sans-serif !important;
    }
    
    /* Spezifisches Styling für das All Day Event-Feld */
    .form-field-all-day {
      margin-bottom: 15px;
      font-family: Arial, sans-serif !important;
    }
    
    /* Styling für die Checkbox */
    .form-field-all-day .k-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    
    /* Optional: Styling für den checked-Zustand */
    .form-field-all-day .k-checkbox:checked {
      background-color: #007bff;
      border-color: #007bff;
    }
    
    /* Label-Styling */
    .form-field label {
      display: block;
      margin-bottom: 5px;
      font-weight: bold;
      font-family: Arial, sans-serif !important;
    }
    
    .form-field input,
    .form-field textarea,
    .form-field .k-dropdownlist,
    .form-field .k-datetimepicker {
      width: 100%;
      font-family: Arial, sans-serif !important;
    }
    
    /* Buttons */
    .form-buttons {
      display: flex;
      justify-content: space-between;
      padding-top: 0;
    }
    
    /* Spezifisches Styling für die Buttons */
    .form-buttons-spaced {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      padding-top: 0;
    }
    
    .c-button {
      padding: 8px 16px;
      font-family: Arial, sans-serif !important;
    }
    
    .c-button-solid-primary {
      background-color: #ff7b00 !important;
      color: #fff !important;
    }
    
    .c-button-solid-base {
      background-color: #6c757d !important;
      color: #fff !important;
    }
    
    /* Überschreibe Kendo-Standardschriftarten */
    .k-input-inner,
    .k-button-text {
      font-family: Arial, sans-serif !important;
    }
  
    `, "",{"version":3,"sources":["webpack://./src/styles/Planning.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;;EAEA;;IAEE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,SAAO,EAAE,oCAAoC;IAC7C,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,mDAAmD;EACvE;;EAEA;IACE,SAAO,EAAE,uDAAuD;IAChE,YAAY,EAAE,8BAA8B;EAC9C;;EAEA,uDAAuD;EACvD;IACE,uBAAuB,EAAE,4BAA4B;EACvD;;EAEA,6EAA6E;EAC7E;;;IAGE,uBAAuB,EAAE,6CAA6C;EACxE;;EAEA,uDAAuD;EACvD;MACI,kCAAkC;MAClC,qBAAqB;IACvB;;IAEA,6DAA6D;IAC7D;MACE,gBAAgB;IAClB;;IAEA,mDAAmD;IACnD;MACE,sBAAsB;MACtB,aAAa;MACb,kBAAkB;MAClB,yCAAyC;MACzC,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,2BAA2B;IAC7B;;IAEA,gBAAgB;IAChB;MACE,YAAY;IACd;;IAEA,WAAW;IACX;MACE,mBAAmB;MACnB,yCAAyC;IAC3C;;IAEA,kDAAkD;IAClD;MACE,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;MACnB,yCAAyC;IAC3C;;IAEA,uDAAuD;IACvD;MACE,WAAW;MACX,gBAAgB,EAAE,kCAAkC;MACpD,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,yBAAyB,EAAE,wDAAwD;MACnF,qBAAqB,EAAE,4BAA4B;MACnD,yCAAyC;IAC3C;;IAEA,oDAAoD;IACpD;MACE,mBAAmB;MACnB,yCAAyC;IAC3C;;IAEA,6BAA6B;IAC7B;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;IACnB;;IAEA,8CAA8C;IAC9C;MACE,yBAAyB;MACzB,qBAAqB;IACvB;;IAEA,kBAAkB;IAClB;MACE,cAAc;MACd,kBAAkB;MAClB,iBAAiB;MACjB,yCAAyC;IAC3C;;IAEA;;;;MAIE,WAAW;MACX,yCAAyC;IAC3C;;IAEA,YAAY;IACZ;MACE,aAAa;MACb,8BAA8B;MAC9B,cAAc;IAChB;;IAEA,yCAAyC;IACzC;MACE,eAAe;MACf,aAAa;MACb,8BAA8B;MAC9B,cAAc;IAChB;;IAEA;MACE,iBAAiB;MACjB,yCAAyC;IAC3C;;IAEA;MACE,oCAAoC;MACpC,sBAAsB;IACxB;;IAEA;MACE,oCAAoC;MACpC,sBAAsB;IACxB;;IAEA,4CAA4C;IAC5C;;MAEE,yCAAyC;IAC3C","sourcesContent":["html, body {\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  \r\n  #Planning.planning-page {\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .card-container.grid {\r\n    flex: 1; /* Nimmt den verfügbaren Platz ein */\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden; /* Verhindert Scrollbars außerhalb des Schedulers */\r\n  }\r\n  \r\n  .card-component {\r\n    flex: 1; /* Scheduler-Container nimmt den restlichen Platz ein */\r\n    height: 100%; /* Volle Höhe des Containers */\r\n  }\r\n  \r\n  /* Überschreibt die Standardhöhe des Kendo Schedulers */\r\n  .k-scheduler {\r\n    height: 100% !important; /* Erzwingt die volle Höhe */\r\n  }\r\n  \r\n  /* Optional: Sicherstellen, dass interne Scheduler-Elemente die Höhe nutzen */\r\n  .k-scheduler-content,\r\n  .k-scheduler-table,\r\n  .k-scheduler-layout {\r\n    height: 100% !important; /* Stellt sicher, dass der Inhalt mitwächst */\r\n  }\r\n  \r\n  /* Entferne den Standard-Hintergrund des Kendo-Popups */\r\n  .k-window-content.k-dialog-content {\r\n      background: transparent !important;\r\n      padding: 0 !important;\r\n    }\r\n    \r\n    /* Stelle sicher, dass das Popup sich an den Inhalt anpasst */\r\n    .k-window.k-dialog {\r\n      max-height: 90vh;\r\n    }\r\n    \r\n    /* Wrapper für die gesamte Form inklusive Buttons */\r\n    .custom-scheduler-form-wrapper {\r\n      background-color: #fff;\r\n      padding: 20px;\r\n      border-radius: 4px;\r\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n      min-width: 300px;\r\n      height: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n    }\r\n    \r\n    /* Form-Inhalt */\r\n    .custom-scheduler-form-content {\r\n      flex-grow: 1;\r\n    }\r\n    \r\n    /* Felder */\r\n    .form-field {\r\n      margin-bottom: 15px;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    /* Spezifisches Styling für das Description-Feld */\r\n    .form-field-description {\r\n      width: 340px;\r\n      margin-top: 20px;\r\n      margin-bottom: 15px;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    /* Styling für das nicht-editierbare Description-Feld */\r\n    .description-display {\r\n      width: 100%;\r\n      min-height: 60px; /* Mindesthöhe wie eine Textarea */\r\n      padding: 8px;\r\n      border: 1px solid #ccc;\r\n      border-radius: 4px;\r\n      background-color: #f5f5f5; /* Leicht grau, um \"nicht editierbar\" zu signalisieren */\r\n      white-space: pre-wrap; /* Zeilenumbrüche erhalten */\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    /* Spezifisches Styling für das All Day Event-Feld */\r\n    .form-field-all-day {\r\n      margin-bottom: 15px;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    /* Styling für die Checkbox */\r\n    .form-field-all-day .k-checkbox {\r\n      width: 20px;\r\n      height: 20px;\r\n      margin-right: 8px;\r\n    }\r\n    \r\n    /* Optional: Styling für den checked-Zustand */\r\n    .form-field-all-day .k-checkbox:checked {\r\n      background-color: #007bff;\r\n      border-color: #007bff;\r\n    }\r\n    \r\n    /* Label-Styling */\r\n    .form-field label {\r\n      display: block;\r\n      margin-bottom: 5px;\r\n      font-weight: bold;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    .form-field input,\r\n    .form-field textarea,\r\n    .form-field .k-dropdownlist,\r\n    .form-field .k-datetimepicker {\r\n      width: 100%;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    /* Buttons */\r\n    .form-buttons {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding-top: 0;\r\n    }\r\n    \r\n    /* Spezifisches Styling für die Buttons */\r\n    .form-buttons-spaced {\r\n      margin-top: 5px;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding-top: 0;\r\n    }\r\n    \r\n    .c-button {\r\n      padding: 8px 16px;\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n    \r\n    .c-button-solid-primary {\r\n      background-color: #ff7b00 !important;\r\n      color: #fff !important;\r\n    }\r\n    \r\n    .c-button-solid-base {\r\n      background-color: #6c757d !important;\r\n      color: #fff !important;\r\n    }\r\n    \r\n    /* Überschreibe Kendo-Standardschriftarten */\r\n    .k-input-inner,\r\n    .k-button-text {\r\n      font-family: Arial, sans-serif !important;\r\n    }\r\n  \r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
